import {useTranslation} from "react-i18next";
import {Link} from "gatsby";
import React from "react";
import {StaticImage} from "gatsby-plugin-image";


export default function RhModules() {
    const {t} = useTranslation();
    return (
        <div className="grid grid-cols-2 gap-3 items-start sm:grid-cols-3 md:grid-cols-3 lg:gap-8 mt-10">

            <div className="grid grid-cols-1 mb-10">
                <div key="" className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center">
                    <div
                        className="lg:col-start-1 xl:col-start-1 md:mt-6 lg:mt-0 lg:row-start-1 lg:col-span-5 xl:col-span-4">
                        <div className="aspect-w-5 items-center col-auto text-center aspect-h-2 overflow-hidden">
                            <div aria-hidden="true">
                                <StaticImage
                                    src={"../../../static/rh/module1.svg"}
                                    alt={t('module_rh_1')}
                                    className="object-cover object-center w-24 h-24 mx-auto "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-start-5 flex-auto lg:row-start-1 lg:col-span-9 xl:col-span-8 px-4 mx-auto">
                        <h2 className="max-w-1xl text-sm md:text-base font-medium text-sepro-1 mb-8 mt-8 mx-auto">{t('module_rh_1')}</h2>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 mb-10">
                <div key="" className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center">
                    <div
                        className="lg:col-start-1 xl:col-start-1 md:mt-6 lg:mt-0 lg:row-start-1 lg:col-span-5 xl:col-span-4">
                        <div className="aspect-w-5 items-center col-auto text-center aspect-h-2 overflow-hidden">
                            <div aria-hidden="true">
                                <StaticImage
                                    src={"../../../static/rh/module2.svg"}
                                    alt={t('module_rh_2')}
                                    className="object-cover object-center w-24 h-24 mx-auto "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-start-5 flex-auto lg:row-start-1 lg:col-span-9 xl:col-span-8 px-4 mx-auto">
                        <h2 className="max-w-1xl text-sm md:text-base font-medium text-sepro-1 mb-8 mt-8 mx-auto">{t('module_rh_2')}</h2>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 mb-10">
                <div key="" className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center">
                    <div
                        className="lg:col-start-1 xl:col-start-1 md:mt-6 lg:mt-0 lg:row-start-1 lg:col-span-5 xl:col-span-4">
                        <div className="aspect-w-5 items-center col-auto text-center aspect-h-2 overflow-hidden">
                            <div aria-hidden="true">
                                <StaticImage
                                    src={"../../../static/kayloo/module3.svg"}
                                    alt={t('module_rh_3')}
                                    className="object-cover object-center w-24 h-24 mx-auto "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-start-5 flex-auto lg:row-start-1 lg:col-span-9 xl:col-span-8 px-4 mx-auto">
                        <h2 className="max-w-1xl text-sm md:text-base font-medium text-sepro-1 mb-8 mt-8 mx-auto">{t('module_rh_3')}</h2>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 mb-10">
                <div key="" className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center">
                    <div
                        className="lg:col-start-1 xl:col-start-1 md:mt-6 lg:mt-0 lg:row-start-1 lg:col-span-5 xl:col-span-4">
                        <div className="aspect-w-5 items-center col-auto text-center aspect-h-2 overflow-hidden">
                            <div aria-hidden="true">
                                <StaticImage
                                    src={"../../../static/kayloo/module4.svg"}
                                    alt={t('module_rh_4')}
                                    className="object-cover object-center w-24 h-24 mx-auto "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-start-5 flex-auto lg:row-start-1 lg:col-span-9 xl:col-span-8 px-4 mx-auto">
                        <h2 className="max-w-1xl text-sm md:text-base font-medium text-sepro-1 mb-8 mt-8 mx-auto">{t('module_rh_4')}</h2>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 mb-10">
                <div key="" className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center">
                    <div
                        className="lg:col-start-1 xl:col-start-1 md:mt-6 lg:mt-0 lg:row-start-1 lg:col-span-5 xl:col-span-4">
                        <div className="aspect-w-5 items-center col-auto text-center aspect-h-2 overflow-hidden">
                            <div aria-hidden="true">
                                <StaticImage
                                    src={"../../../static/rh/module5.svg"}
                                    alt={t('module_rh_5')}
                                    className="object-cover object-center w-24 h-24 mx-auto "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-start-5 flex-auto lg:row-start-1 lg:col-span-9 xl:col-span-8 px-4 mx-auto">
                        <h2 className="max-w-1xl text-sm md:text-base font-medium text-sepro-1 mb-8 mt-8 mx-auto">{t('module_rh_5')}</h2>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 mb-10">
                <div key="" className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center">
                    <div
                        className="lg:col-start-1 xl:col-start-1 md:mt-6 lg:mt-0 lg:row-start-1 lg:col-span-5 xl:col-span-4">
                        <div className="aspect-w-5 items-center col-auto text-center aspect-h-2 overflow-hidden">
                            <div aria-hidden="true">
                                <StaticImage
                                    src={"../../../static/rh/module8.svg"}
                                    alt={t('module_rh_8')}
                                    className="object-cover object-center w-24 h-24 mx-auto "
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:col-start-5 flex-auto lg:row-start-1 lg:col-span-9 xl:col-span-8 px-4 mx-auto">
                        <h2 className="max-w-1xl text-sm md:text-base font-medium text-sepro-1 mb-8 mt-8 mx-auto">{t('module_rh_8')}</h2>
                    </div>
                </div>
            </div>
        </div>
    )
}